import React from 'react'

import {PageTitle} from '../../components';

import Layout from '../../components/about/Layout';

// import {About} from '../../components';


// export default About;

export default () => (
  <Layout>
    <PageTitle title='公司简介'/>
  </Layout>
)


// WEBPACK FOOTER //
// ./src/pages/about/index.js